import { FC } from 'react';
import { getInitials } from 'utils/getInitials';
import { useSendCommunicationModal } from '../context/SendCommunicationModalContext';
import { Recipient } from '../types/Recipient';

type RecipientChipProps = {
  recipient: Recipient;
};

const RecipientChip: FC<RecipientChipProps> = ({ recipient }) => {
  const { actions } = useSendCommunicationModal();

  const handleRemoveRecipient = () => {
    actions.handleRemoveRecipient(recipient.id);
  };

  const { name, email } = recipient;

  const initials = getInitials(name);

  return (
    <div className="recipient-chip d-inline-flex align-items-center border rounded-pill me-2 mb-2 mr-1">
      <span className="recipient-chip__avatar d-flex align-items-center justify-content-center rounded-circle text-white fw-semibold me-2 bg-primary">
        {initials}
      </span>
      <span className="recipient-chip__name fw-medium ml-1">{name}</span>
      <span className="recipient-chip__email text-muted ml-1">({email})</span>
      <button
        type="button"
        onClick={handleRemoveRecipient}
        className="recipient-chip__remove btn btn-sm p-0 d-flex align-items-center justify-content-center border-0"
      >
        <em className="icon ni ni-cross" />
      </button>
    </div>
  );
};

export default RecipientChip;
